import { ChangeDetectorRef } from '@angular/core';
import { UiButtonComponent, UiHoverLabelButtonComponent } from '../button';
import * as i0 from "@angular/core";
import * as i1 from "../dialog/dialog";
import * as i2 from "../shared/shared";
const _c0 = ["*"];
function UiHelpButtonComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r1.htmlContent, i0.ɵɵsanitizeHtml);
  }
}
export let UiHelpButtonComponent = /*#__PURE__*/(() => {
  class UiHelpButtonComponent {
    constructor(cd) {
      this.cd = cd;
      this.toggled = false;
    }
    toggle() {
      this.toggled = !this.toggled;
      this.cd.markForCheck();
    }
    visibleChange(e) {
      this.toggled = false;
      this.cd.markForCheck();
    }
    static {
      this.ɵfac = function UiHelpButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiHelpButtonComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiHelpButtonComponent,
        selectors: [["ui-help-button"]],
        hostAttrs: ["ngSkipHydration", "true"],
        inputs: {
          htmlContent: "htmlContent"
        },
        ngContentSelectors: _c0,
        decls: 8,
        vars: 6,
        consts: [["dialogComp", ""], ["uiHoverLabelButton", "", "iconSize", "sm", "rounded", "true", 1, "ui-button-outline", 3, "click", "icon", "toggled"], ["header", "Weitere Informationen", "appendTo", "body", 3, "visibleChange", "visible", "modal", "dismissableMask"], [3, "innerHTML"], ["uiButton", "", "label", "Alles klar!", 1, "small", 3, "click"]],
        template: function UiHelpButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div")(1, "button", 1);
            i0.ɵɵlistener("click", function UiHelpButtonComponent_Template_button_click_1_listener() {
              return ctx.toggle();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "ui-dialog", 2, 0);
            i0.ɵɵtwoWayListener("visibleChange", function UiHelpButtonComponent_Template_ui_dialog_visibleChange_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.toggled, $event) || (ctx.toggled = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("visibleChange", function UiHelpButtonComponent_Template_ui_dialog_visibleChange_2_listener($event) {
              return ctx.visibleChange($event);
            });
            i0.ɵɵprojection(4);
            i0.ɵɵconditionalCreate(5, UiHelpButtonComponent_Conditional_5_Template, 1, 1, "div", 3);
            i0.ɵɵelementStart(6, "ui-footer")(7, "button", 4);
            i0.ɵɵlistener("click", function UiHelpButtonComponent_Template_button_click_7_listener($event) {
              i0.ɵɵrestoreView(_r1);
              const dialogComp_r3 = i0.ɵɵreference(3);
              return i0.ɵɵresetView(dialogComp_r3.close($event));
            });
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("icon", "info")("toggled", ctx.toggled);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("visible", ctx.toggled);
            i0.ɵɵproperty("modal", true)("dismissableMask", true);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.htmlContent ? 5 : -1);
          }
        },
        dependencies: [UiHoverLabelButtonComponent, UiButtonComponent, i1.UiDialogComponent, i2.UiFooterComponent],
        styles: [".ui-button[_ngcontent-%COMP%]{padding:4px}.ui-button[_ngcontent-%COMP%]     .ui-button-content{min-width:15px}.popup[_ngcontent-%COMP%]{position:absolute;right:5px;box-shadow:0 2px 3px #00000059;width:340px;z-index:1000;background:#fff;overflow:auto}.popup.down[_ngcontent-%COMP%]{top:70px}.popup.up[_ngcontent-%COMP%]{bottom:60px}.popup[_ngcontent-%COMP%]   .block[_ngcontent-%COMP%]{padding:20px;text-align:center}.popup[_ngcontent-%COMP%]   strong[_ngcontent-%COMP%]{font-weight:600;color:var(--contrastColor)}@media (max-width: 400px){.popup[_ngcontent-%COMP%]{width:300px;right:5px}}"],
        changeDetection: 0
      });
    }
  }
  return UiHelpButtonComponent;
})();